const days = [
    {
        id: "senin",
        label: "Senin",
    },
    {
        id: "jumat",
        label: "Jum'at",
    },
    {
        id: "selasa",
        label: "Selasa",
    },
    {
        id: "sabtu",
        label: "Sabtu",
    },
    {
        id: "rabu",
        label: "Rabu",
    },
    {
        id: "minggu",
        label: "Minggu",
    },
    {
        id: "kamis",
        label: "Kamis",
    },
];

export default days;